/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_6_TInputs */

const en_cp_cal_6_t = /** @type {(inputs: Cp_Cal_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardening & report`)
};

const id_cp_cal_6_t = /** @type {(inputs: Cp_Cal_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardening & laporan`)
};

/**
* | output |
* | --- |
* | "Hardening & report" |
*
* @param {Cp_Cal_6_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_6_t = /** @type {((inputs?: Cp_Cal_6_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_6_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_6_t(inputs)
	return en_cp_cal_6_t(inputs)
});